import React from "react";

class AppErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
        };
    }

    static getDerivedStateFromError() {
        return {
            hasError: true,
        };
    }

    componentDidCatch(error, errorInfo) {
        console.error("Erreur capturée par AppErrorBoundary:", error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{
                    minHeight: "60vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: 24,
                    background: "#f8fafc",
                }}>
                    <div style={{
                        maxWidth: 520,
                        background: "#fff",
                        borderRadius: 16,
                        padding: 24,
                        border: "1px solid #e5e7eb",
                        boxShadow: "0 12px 30px rgba(15,23,42,0.08)",
                    }}>
                        <h2 style={{ color: "#204385", marginTop: 0 }}>
                            Une erreur est survenue
                        </h2>
                        <p style={{ color: "#64748b" }}>
                            La page n&apos;a pas pu être affichée correctement.
                        </p>
                        <button
                            onClick={() => window.location.reload()}
                            style={{
                                border: "none",
                                borderRadius: 10,
                                padding: "10px 16px",
                                background: "#204385",
                                color: "#fff",
                                cursor: "pointer",
                            }}
                        >
                            Actualiser
                        </button>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default AppErrorBoundary;
